import { cn } from '@/lib/utils'
import { Markdown } from '@/lib/ui-kit/components/Markdown.component'

interface BoardMemberProps {
  imageUrl: string
  name: string
  role: string
  links: {
    name: string
    url: string
  }[]
  bio: string
  alternativeText: string
  className?: string
}

const CardBoardMember = ({
  imageUrl,
  name,
  role,
  links,
  bio,
  alternativeText,
  className,
}: BoardMemberProps) => {
  return (
    <>
      <div
        className={cn(
          className,
          'hidden h-full w-full flex-col px-[10px] py-[20px] xl:flex xl:p-0',
        )}
      >
        <div className="mb-4 w-full shrink-0 bg-gray-50">
          <img
            className="aspect-square w-full object-cover"
            alt={alternativeText}
            src={imageUrl}
          />
        </div>
        <div className="mb-4 flex flex-1 flex-col">
          <h4 className="paragraph-l mb-1 font-medium text-gray-1000">
            {name}
          </h4>
          <h5 className="paragraph-xs mb-1 font-medium text-gray-800">
            {role}
          </h5>
          <div className="paragraph-s flex-1 font-medium text-gray-800">
            <Markdown>{bio}</Markdown>
          </div>
        </div>
        <div className="flex flex-row flex-wrap items-start justify-start gap-[12px] border-t border-gray-400 pt-4 text-mini">
          {links.map(({ name, url }: { name: string; url: string }) => (
            <a
              className="paragraph-s rounded-[32px] bg-gray-50 px-4 py-[7px] font-medium transition-colors duration-150 ease-in-out hover:bg-base-dark hover:text-base-light"
              href={url}
              key={name}
              target="_blank"
              rel="noopener noreferrer"
            >
              {name}
            </a>
          ))}
        </div>
      </div>
      <div
        className={cn(
          className,
          'grid h-full w-full grid-cols-2 gap-x-4 px-[10px] py-[16px] xl:hidden xl:p-0',
        )}
      >
        <div className="mb-4 w-full shrink-0 bg-gray-50">
          <img
            className="aspect-square w-full object-cover"
            alt={alternativeText}
            src={imageUrl}
          />
        </div>
        <div className="mb-4 flex flex-1 flex-col justify-end">
          <h4 className="paragraph-l mb-1 font-medium text-gray-1000">
            {name}
          </h4>
          <h5 className="paragraph-s font-medium text-gray-800">{role}</h5>
        </div>
        <div className="col-span-2 flex-1 text-mini font-medium leading-[1.375rem] text-gray-800">
          <Markdown>{bio}</Markdown>
        </div>
        <div className="col-span-2 flex flex-row flex-wrap items-start justify-start gap-[12px] border-b border-gray-400 py-4 text-mini">
          {links.map(({ name, url }: { name: string; url: string }) => (
            <a
              className="paragraph-s rounded-[32px] bg-base-light px-4 py-[7px] font-medium transition-colors duration-150 ease-in-out hover:bg-base-dark hover:text-base-light"
              href={url}
              key={name}
              target="_blank"
              rel="noopener noreferrer"
            >
              {name}
            </a>
          ))}
        </div>
      </div>
    </>
  )
}

export default CardBoardMember
